
import _ from 'lodash'
export default {
    props: {
        client: {
            type: Object,
            default: null
        },
        attendees: {
            type: Array,
            default: () => []
        },
        autoAdvance: {
            type: Boolean,
            default: true
        },
        addingAttendees: {
            type: Boolean,
            default: true,
        },
        aep: {
            type: Boolean,
            default: false
        },
        titleClass: {
            type: String,
            default: 'text-primary'
        }
    },
    data () {
        return {
            soas: [],
            clientsList: [],
        }
    },
    computed: {
        allClientsHaveSoas () {
            return this.clientsList.every(c => c?.soa60days || c.soa)
        }
    },
    watch: {
        attendees: {
            deep: true,
            immediate: true,
            cache: false,
            handler () {
                return this.updateClientsList()
            }
        },
        client: 'updateClientsList'
    },
    mounted () {
        window.$soas = this
        this.updateClientsList()
        if (this.allClientsHaveSoas) {
            this.$emit('input', this.soas)
        }
    },
    methods: {
        updateClientsList () {
            this.clientsList = [{ ...this.client, client0: true }]
            if (this.addingAttendees) {
                this.clientsList = this.clientsList.concat(this.attendees)
            }
        },
        getClientSetValuePrefix (client) {
            if (!client.client0) {
                return {
                    list: 'attendees',
                    index: _.findIndex(this.attendees, c => c.email === client.email && c.dob === client.dob)
                }
            }
            return {}
        },
        setSoa (c, payload) {
            const setValuePrefix = this.getClientSetValuePrefix(c)
            this.$emit('set-value', { ...setValuePrefix, key: 'soa', value: payload })

            // below is a wonky hack to force the current UI to update, since
            // setting the surveyModel.value is not reload the propsData of the vcomponent
            c.soa = payload
            this.updateClientsList()

            this.soas.push(payload)
            if (this.allClientsHaveSoas) {
                this.$emit('input', this.soas)
            }
        }
    }
}
